import { rowNeedsMigration } from './problem-filter';
import type { EmailKeyUserRow } from './types';

export type BulkLeftoverOp = 'migrate' | 'send-email' | 'restore';

export function leftoverSkipReason(
  row: EmailKeyUserRow,
  op: BulkLeftoverOp,
): string | null {
  switch (op) {
    case 'migrate':
      return rowNeedsMigration(row) ? null : 'not leftover-legacy';
    case 'send-email':
      return row.invitedNotSignedIn && !row.deleted ? null : 'not invited';
    case 'restore':
      return row.deleted ? null : 'not deleted';
    default:
      return 'unknown';
  }
}

export function eligibleEmailKeys(
  rows: EmailKeyUserRow[],
  selected: ReadonlySet<string>,
  op: BulkLeftoverOp,
): string[] {
  return rows
    .filter((row) => selected.has(row.emailKey) && leftoverSkipReason(row, op) === null)
    .map((row) => row.emailKey);
}
